export const AuthForm = {
	el: {
		root: document.querySelector<HTMLElement>(".auth-form"),
		navButtons: document.querySelectorAll<HTMLButtonElement>(
			".auth-form__nav-button",
		),
		forms: document.querySelectorAll<HTMLFormElement>(".auth-form__form"),
		methods: document.querySelector<HTMLElement>(".auth-form__method"),
		steps: document.querySelectorAll<HTMLElement>(".auth-form__step"),
		titles: document.querySelectorAll<HTMLElement>(".audkenni-card__title"),
		texts: document.querySelectorAll<HTMLElement>(".audkenni__text"),
		simForm: document.querySelector<HTMLFormElement>(
			'.auth-form__form[data-method="sim"]',
		),
		appForm: document.querySelector<HTMLFormElement>(
			'.auth-form__form[data-method="app"]',
		),
		message: document.querySelector<HTMLElement>(".auth-form__message"),
		inputs: document.querySelectorAll<HTMLInputElement>(".auth__input"),
		challengeText: document.querySelector<HTMLElement>(
			".auth-form__challenge-text",
		),
	},
	init() {
		this.handleNav();
		this.formEvents();
		this.inputEvents();
	},
	handleSubmit(form: HTMLFormElement) {
		form.addEventListener("submit", async (e) => {
			try {
				e.preventDefault();
				const formData = new FormData(form);
				const data = {
					culture: formData.get("culture"),
					authType: formData.get("authType"),
					phone: formData.get("Phone"),
					ssn: formData.get("SSN"),
					ufprt: formData.get("ufprt"),
					isCheckout: formData.get("isCheckout"),
				};

				const request = await fetch("/umbraco/surface/auth/login", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				});

				if (!request.ok) {
					console.error("[auth-form | submit | !request.ok]");
					this.handleMessage(true, "error");
					return;
				}

				this.poll(request, form);
			} catch (error) {
				console.error("[auth-form | catcn | error]", error);
			}
		});
	},
	async poll(request, form) {
    try {
      const res = await request.json();
      this.changeStep(2, res);
      const redirect = form.querySelector('input[name="redirect"]')?.value;

      const req = await fetch("/umbraco/surface/auth/poll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          culture: "is-IS",
          authIdentifier: res.Identifier,
          redirect: redirect,
        }),
      });

      if (!req.ok) {
        console.error("[auth-form | poll | !req.ok]");
        this.changeStep(1);
        this.handleMessage(true, "error");
        return;
      }

      const response = await req.json();
      if (response.success) {
        console.log('redirecting to', response.redirect);
        window.location.href = response.redirect;
      } else {
        this.changeStep(1);
        this.handleMessage(true, "error");
      }
    }
    catch (error) {
      console.error("[auth-form | poll | error]", error);
    }
	},
	handleMessage(show = false, type = "error") {
		if (show) {
			this.el.message.style.display = "block";

			setTimeout(() => {
				this.el.message.style.display = "none";
			}, 5000);
		} else {
			this.el.message.style.display = "none";
		}

		this.el.message.classList.add(`message--${type}`);
	},

	changeStep(stepNumber: number, request = null) {
		this.el.steps.forEach((step) => {
			step.style.display = "none";
		});
		const chosenStep = this.el.root.querySelector<HTMLElement>(
			`.auth-form__step[data-step="${stepNumber}"]`,
		);
		if (chosenStep) {
			chosenStep.style.display = "flex";
		}
		if (stepNumber === 2) {
			this.el.challengeText.innerText = request.Challenge;
		}
	},
	handleNav() {
		this.el.navButtons.forEach((button) => {
			button.addEventListener(
				"click",
				(e: Event & { target: HTMLButtonElement }) => {
					this.changeForm(e.target.dataset.method);
				},
			);
		});
	},
	changeForm(method: string) {
		this.el.forms.forEach((item) => {
			item.classList.remove("auth-form__form--active");
		});
		this.el.navButtons.forEach((button) => {
			button.classList.remove("auth-form__nav-button--active");
		});
		this.el.titles.forEach((title) => {
			title.classList.remove("audkenni-card__title--active");
		});
		this.el.texts.forEach((text) => {
			text.classList.remove("audkenni__text--active");
		});
		this.el.forms.forEach((form) => {
			if (form.dataset.method === method) {
				form.classList.add("auth-form__form--active");
			}
		});
		this.el.navButtons.forEach((button) => {
			if (button.dataset.method === method) {
				button.classList.add("auth-form__nav-button--active");
			}
		});
		this.el.titles.forEach((title) => {
			if (title.dataset.method === method) {
				title.classList.add("audkenni-card__title--active");
			}
		});
		this.el.texts.forEach((text) => {
			if (text.dataset.method === method) {
				text.classList.add("audkenni__text--active");
			}
		});
	},
	formEvents() {
		this.el.forms.forEach((form) => {
			this.handleSubmit(form);
		});
	},
	inputEvents() {
		this.el.inputs.forEach((input) => {
			// This prevents ctrl + v
			input.onpaste = (e) => e.preventDefault();

			input.addEventListener(
				"keyup",
				(e: Event & { target: HTMLInputElement; key: string }) => {
					if (e.key !== "Backspace") {
						const regex = /^[0-9-]*$/;

						if (!regex.test(e.target.value)) {
							// If the input doesn't match the pattern, clear the input value
							e.target.value = e.target.value.replace(/[^0-9-]/g, "");
						}

						if (
							e.target.dataset.mask === "ssn" &&
							e.target.value.length === 6
						) {
							e.target.value = `${e.target.value}-`;
						}
						if (
							e.target.dataset.mask === "tel" &&
							e.target.value.length === 3
						) {
							e.target.value = `${e.target.value}-`;
						}
					}

					const parent = e.target.closest<HTMLElement>(
						".auth-form__input-wrap",
					);

					if (e.target.value.length >= e.target.maxLength) {
						parent
							?.querySelector<HTMLButtonElement>(".auth-form__submit")
							?.removeAttribute("disabled");
					} else {
						parent
							?.querySelector<HTMLButtonElement>(".auth-form__submit")
							?.setAttribute("disabled", "");
					}
				},
			);
		});
	},
};

export default AuthForm;
